module.exports = __webpack_public_path__ + "static/img/vista.bbaf0e49.png";